import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MobileGuard implements CanActivate {
  constructor(private router:Router){}
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      if(document.body.clientWidth > 992){
        return true;
      }else{
        let langCode = localStorage.getItem('langCode') ? localStorage.getItem('langCode') : 'en';
        this.router.navigate(['/'+langCode]);
        return false
      }
  }
  
}
